import axios from "axios";

// Read base URL from environment variable
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // if your backend uses cookies
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
